import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class BaseAiService {
    /** Region: Variable Declaration */
    private readonly AI_API_URL: string = environment.aiApiUrl;

    /** Region: Constructor */
    constructor(private http: HttpClient) {
    }

    get(url: string) {
        const fullURL = this.getURL(url);
        const headers = this.getHeaders();
        return this.http.get(fullURL, {
            headers: headers,
            observe: 'response'
        });
    }

    post(url: string, bodyModel: any) {
        const fullURL = this.getURL(url);
        const headers = this.getHeaders();
        return this.http.post(fullURL, bodyModel, {
            headers: headers
        });
    }

    put(url: string, bodyModel: any) {
        const fullURL = this.getURL(url);
        const headers = this.getHeaders();
        return this.http.put(fullURL, bodyModel, {
            headers: headers
        });
    }

    patch(url: string, bodyModel: any) {
        const fullURL = this.getURL(url);
        const headers = this.getHeaders();
        return this.http.patch(fullURL, bodyModel, {
            headers: headers
        });
    }

    postFormData(url: string, formData: FormData) {
        const fullURL = this.getURL(url);
        // Do NOT set Content-Type — browser sets multipart/form-data with boundary.
        // Authorization (Bearer service token) is applied by CredentialsInterceptor.
        const headers = new HttpHeaders({'accept': 'application/json'});
        return this.http.post(fullURL, formData, { headers });
    }

    delete(url: string) {
        const fullURL = this.getURL(url);
        const headers = this.getHeaders();
        return this.http.delete(fullURL, {
            headers: headers
        });
    }

    private getURL(url: string): string {
        // Join base + path with exactly one slash, tolerating a base URL that is
        // missing (or has an extra) trailing slash. Without this, a base such as
        // "http://localhost:8080" produces the invalid "http://localhost:8080pebbl/…".
        const base = (this.AI_API_URL || '').replace(/\/+$/, '');
        const path = url.replace(/^\/+/, '');
        return `${base}/${path}`;
    }

    private getHeaders(authorizationHeader: boolean = true): HttpHeaders {
        // Authorization (Bearer service token) is applied by CredentialsInterceptor for the AI host.
        let headers: HttpHeaders = new HttpHeaders();
        headers = headers.append('accept', 'application/json');
        headers = headers.append('Content-Type', 'application/json');
        return headers;
    }
}
